import React from "react";

const LazyForgotPassword = React.lazy(() => import("./forgot-password"));

const ForgotPassword = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyForgotPassword {...props} />
  </React.Suspense>
);

export default ForgotPassword;
